import { SharendipityUser } from './sharendipity-user';

export type BasicUserInfo = Pick<
  SharendipityUser,
  'id' | 'name' | 'photoURL' | 'email' | 'phoneNumber'
>;
